import React from 'react'
import { useDispatch } from 'react-redux';
import { addToCart } from '../redux/Actions/CartActions';

export const AddTocartButton = ({product,quantity,hover=1}) => {
    const dispatch = useDispatch();
    const addToCart_ = (productId, qty) => {
      dispatch(addToCart(productId, qty));
    }
    const setHoverButon=()=>{
      if(hover==1){
        return "bg-[--color-button-1]  hover:bg-[--color-button-3] hover:text-white";
      }
      if(hover==2){
        return "bg-[--color-button-3]  hover:bg-[--color-button-2] text-white hover:text-black";
      }
    }
  return (
    <button className={`mt-3 ${setHoverButon()}   group-hover/card:bg-[--color-button-3] group-hover/card:text-white text-xs md:text-sm font-medium py-2 px-4  rounded-full transition-all duration-300`} onClick={() => addToCart_(product?._id, quantity??1)}>
   Thêm vào giỏ hàng
  </button>
  )
}
